import "../../resources/styles/uploadBox.css"
import { ArrowRepeat, CheckCircle, Eye } from 'react-bootstrap-icons';
import { useFileUpload } from '../../hooks/useFileUpload';
import { useEffect } from "react";
import { properties } from '../../utils/Properties_es';

const UploadBox = ({
    label,
    onFileSelect,
    initialData,
    disabled = false,
    accept = "image/*,application/pdf",
    maxSizeBytes = 10 * 1024 * 1024,
    invalidTypeMessage,
    invalidSizeMessage
}) => {
    const {
        file,
        previewURL,
        isDragging,
        errorMessage,
        handleChange,
        handleDragLeave,
        handleDragOver,
        handleDrop,
        setFile,
        setPreviewURL
    } = useFileUpload(onFileSelect, {
        accept,
        maxSizeBytes,
        invalidTypeMessage,
        invalidSizeMessage
    });

    useEffect(() => {
        if (initialData) {
            setFile(initialData);
            setPreviewURL(URL.createObjectURL(initialData));
        }
    }, [initialData])

    return (
        <>
            {!file ? (
                <div
                    className={`upload-box ${isDragging ? "dragging" : ""}`}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                >
                    <div className='upload-label'>
                        <label>
                            <input
                                type="file"
                                accept={accept}
                                className='upload-input'
                                onChange={handleChange}
                                 disabled={disabled}
                            />
                            + {label}
                        </label>
                    </div>
                </div>
            ) : (
                <>
                    <div
                        className={`file-status-box ${isDragging ? "dragging" : ""}`}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                    >
                        <div className='file-status-added d-flex justify-content-center align-items-center gap-3'>
                            <CheckCircle className='icon-check' size={18} type='button' />
                            <span>{properties.upload_added}</span>
                            <Eye
                                size={22}
                                className='icon-eye'
                                type='button'
                                onClick={() => window.open(previewURL, '_blank')} />
                        </div>
                    </div>
                    <div className='upload-actions'>
                        <div className='btn-reupload'>
                            <label>
                                <ArrowRepeat size={14} style={{ marginRight: "4px" }} />
                                <span type='button'>{properties.upload_reattach}</span>
                                <input
                                    type='file'
                                    accept={accept}
                                    className='upload-input'
                                    onChange={handleChange}
                                    disabled={disabled}
                                />
                            </label>
                        </div>
                    </div>
                </>
            )}
            {errorMessage && (
                <div className='mt-2' style={{ color: 'red', fontSize: 13 }}>
                    {errorMessage}
                </div>
            )}
        </>
    )
}

export default UploadBox
